"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BaseClickSchema = void 0;
const baseSchema_1 = __importDefault(require("./baseSchema"));
class BaseClickSchema extends baseSchema_1.default {
    constructor({ componentName }) {
        super();
        this.componentName = componentName;
    }
    prepare() {
        return {
            ...super.prepare(),
            componentName: this.componentName
        };
    }
}
exports.BaseClickSchema = BaseClickSchema;
